import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { getPhotos} from '../services/photoService';

function extractLocation(title) {
  const t = (title || '').toUpperCase();
  if (!t) return null;
  if (t.includes('KÖYÜ')) return `${t.split(' ')[0]} KÖYÜ`;
  if (t.includes('MAHALLE')) return `${t.split(' ')[0]} MAHALLESİ`;
  return t;
}

export function usePhotos() {
  const [fbPhotos, setFbPhotos] = useState([]);
  const [jsonPhotos, setJsonPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  // JSON — bir kere yükle
  useEffect(() => {
    getPhotos().then(data => {
      setJsonPhotos(data.filter(p => p.source !== 'fb'));
      setLoading(false);
    });
  }, []);

  // Firebase — realtime
  useEffect(() => {
    const q = query(collection(db, 'resimler'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(
      q,
      snap => {
        const photos = snap.docs.map(doc => {
          const d = doc.data();
          return {
            id: doc.id,
            title: d.title || '',
            description: d.description || '',
            imageUrl: d.imageUrl || '',
            location: d.location || extractLocation(d.title),
            uploadDate: d.createdAt?.toDate?.() ?? new Date(0),
            source: 'fb',
            isValid: true,
          };
        });
        setFbPhotos(photos);
      },
      err => console.warn('Firestore photos error:', err)
    );
    return () => unsub();
  }, []);

  // FB önce, JSON sonra
  const photos = [...fbPhotos, ...jsonPhotos].sort((a, b) => b.uploadDate - a.uploadDate);

  return { photos, loading };
}